import React, { useContext } from 'react';

import { ContentEditorContext } from './ContentEditorProvider';

export const useContentEditorProvider = (): React.ContextType<typeof ContentEditorContext> => {
  const context = useContext(ContentEditorContext);

  return context;
};
